import { configureStore } from '@reduxjs/toolkit';
import { restV4Api } from '@/api/generated/restV4-api';
import table from '@/redux/slices/table/slice';

const store = configureStore({
  reducer: {
    [restV4Api.reducerPath]: restV4Api.reducer,
    table,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(restV4Api.middleware),
});

export default store;

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
